<h2>{{ data.title }}</h2>
<div id="contenedor">
    <iframe [src]="safeVideoUrl" width="100%" height="100%" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    <div id="superpuesto"></div>
</div>
